module.exports = __webpack_public_path__ + "img/eita.62c6391.svg";